module.exports = __webpack_public_path__ + "img/B86137_FBCA6F_6F3C37_040404-256px.11f8129f.png";